(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/matchen/views/odds-slider/matchen-odds-headings.js') >= 0) return;  svs.modules.push('/modules/matchen/views/odds-slider/matchen-odds-headings.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.matchen=_svs.matchen||{};
_svs.matchen.templates=_svs.matchen.templates||{};
svs.matchen.templates.matchen_odds_headings = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "        <div class=\"f-bold matchen-flex-item\">\n            "
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"match") : depth0)) != null ? lookupProperty(stack1,"participants") : stack1)) != null ? lookupProperty(stack1,"0") : stack1)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + " - "
    + alias2(alias1(((stack1 = ((stack1 = ((stack1 = (depth0 != null ? lookupProperty(depth0,"match") : depth0)) != null ? lookupProperty(stack1,"participants") : stack1)) != null ? lookupProperty(stack1,"1") : stack1)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "\n        </div>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"matchen-flex-container matchen-odds-list-headings\">\n"
    + ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"events") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":2,"column":4},"end":{"line":6,"column":13}}})) != null ? stack1 : "")
    + "    <div class=\"align-right f-bold matchen-flex-item\">\n        <br>\n        <a href=\"#\" title=\"Ändra sortering\" class=\"fc-grey-600 js-all-odds-sort matchen-odds-link\">\n            Odds <i class=\"icon-default icon-caret-down match-sort-icon\"></i>\n        </a>\n    </div>\n</div>";
},"useData":true});
Handlebars.partials['svs-matchen-matchen_odds_headings'] = svs.matchen.templates.matchen_odds_headings;
})(svs, Handlebars);


 })(window);